import { FormControlLabel, Switch } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { useUpdateNotificationPreference } from '@hooks/api/notification';

const messages = defineMessages({
  yes: {
    id: 'GLOBAL.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'GLOBAL.no',
    defaultMessage: 'No',
  },
});

interface UserNotificationPreferenceProps {
  user_id: string;
  identifier: string;
  enabled: boolean;
}

function UserNotificationPreference({
  enabled: initEnabled,
  identifier,
  user_id,
}: UserNotificationPreferenceProps) {
  const { formatMessage } = useIntl();
  const [updateNotificationPreference, loading] =
    useUpdateNotificationPreference();
  const [enabled, setEnabled] = React.useState(initEnabled);

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = async (
    event
  ) => {
    setEnabled(event.target.checked);
    await updateNotificationPreference({
      input: {
        email_enabled: event.target.checked,
        identifier,
        user_id,
      },
    });
  };

  return (
    <FormControlLabel
      control={
        <Switch checked={enabled} disabled={loading} onChange={handleChange} />
      }
      label={formatMessage(enabled ? messages.yes : messages.no)}
    />
  );
}

export default UserNotificationPreference;
